import services from './services';
import {
    cloneDeep,
    util,
    isCorrectVal,
    isDate,
    lg
} from 'utils';
import addParent from "../addParent/index.vue" //添加家长
import addBaby from "../addBaby/index.vue" //添加宝贝
export default {
    mixins: [services],
    components: {
        addParent,
        addBaby
    },
    data() {
        return {
            loading: false,
            dialogVisible: false,
            lists: [],
            lists2: [],
            title: '',
            BabyName: '',
            ClassId: '',
            PackageId:'',
            OrderSource: '',
            row: {},
            pageIndex: 1,
            pageSizes: [10, 20, 50],
            pageSize: 10,
            totalSize: '',
            isTip: false
        }
    },
    methods: {
        show(options) {
            this.BabyName = ''
            this.OrderSource = ''
            this.isTip = false
            this.lists = []
            this.lists2 = []
            this.dialogVisible = true
            this.title = options.title
            this.PackageId=options.PackageId
            if (options.ClassId) {
                this.ClassId = options.ClassId
                
            } else {
                // 无园所
                this.ClassId = ''
            }
            if (options.OrderSource) {
                this.OrderSource = options.OrderSource
            }
        },
        search() {
            if (this.BabyName == '') {
                this.$notify({
                    title: '警告',
                    message: '请先输入宝贝姓名搜索',
                    type: 'warning'
                });
                this.isTip = true
            } else {
                this.isTip = false
                if (this.ClassId == '') {
                    this.GetBabyByPage(this.BabyName,this.PackageId)
                } else {
                    this.GetBabyList(this.ClassId, this.BabyName,this.PackageId)
                }

            }

        },
        // 新增宝贝之后默认选中
        getBabyList(name) {
            this.BabyName = name
            if (this.ClassId == '') {
                this.GetBabyByPage(name, true)
            } else {
                this.GetBabyList(this.ClassId, name, true)
            }

        },
        //查询功能
        handleSizeChange: function (val) {
            this.pageSize = val;
            this.GetBabyByPage(this.BabyName,this.PackageId)
        },
        handleCurrentPage: function (val) {
            this.pageIndex = val;
            this.GetBabyByPage(this.BabyName,this.PackageId)

        },
        // 添加宝贝
        addBaby() {
            this.$refs.refAddBaby.show({
                title: '添加宝贝',
                ClassId: this.ClassId
            })
        },
        // 选择转介绍宝贝
        handleCurrentChange(val) {
            if (val == null) {
                return;
            }
            this.row = val
            if (this.row.BabyId !== undefined) {
                this.$emit('babyInfo', this.row)
                this.$emit('parentInfo', this.row)
                this.dialogVisible = false
            } else {
                this.$notify({
                    title: '警告',
                    message: '请选择转介绍宝贝',
                    type: 'warning'
                });
                return;
            }

        },
        // 确定
        submit() {
            if (this.row.BabyId !== undefined) {
                this.$emit('babyInfo', this.row)
                this.$emit('parentInfo', this.row)
                this.dialogVisible = false
            } else {
                this.$notify({
                    title: '警告',
                    message: '请选择转介绍宝贝',
                    type: 'warning'
                });
                return;
            }
        }


    },
    computed: {

    }
}


// WEBPACK FOOTER //
// ./src/pages/Order/LBHomeOrder/components/babyList/vm.js